import {ThemeType} from '../../../theme/types';
import {BaseBorderPxProps} from '../../base/types';
import {mapFocusBorderToBaseProperties} from '../../themed/functions';
import {InputProps} from '../types';

export const mapInputBorderToBaseProperties = (
  theme: ThemeType,
  focus: boolean,
  {round, clear}: InputProps,
): BaseBorderPxProps => {
  const borders = mapFocusBorderToBaseProperties(theme, focus ? 'on' : 'off', {
    borderRadius: round ? '9999' : '4',
  });
  return {
    ...borders,
    ...(focus
      ? {}
      : {
          borderColor: clear ? theme.colors['border_mono_30'] : undefined,
          borderWidth: clear ? theme.borders['1'] : undefined,
          borderStyle: clear ? 'solid' : undefined,
        }),
  };
};
